module.exports = __webpack_public_path__ + "static/media/unicorn.44dc3fee.svg";